module.exports = __webpack_public_path__ + "static/media/SM-ST-6.7b4a7a88.mp3";